export const DISPLAY_PANEL_LOGIN = 'DISPLAY_PANEL_LOGIN';
export const DISPLAY_PANEL_REQUESTINVITE = 'DISPLAY_PANEL_REQUESTINVITE';

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const FINALIZE_SCA = 'FINALIZE_SCA';
